function decimateData(data, maxPoints) {
  if (data.length <= maxPoints) return { data: data, indices: null };
  var step = Math.ceil(data.length / maxPoints);
  var indices = [];
  for (var i = 0; i < data.length; i += step) {
    indices.push(i);
  }
  if (indices[indices.length - 1] !== data.length - 1) {
    indices.push(data.length - 1);
  }
  var decimated = indices.map(function(idx) { return data[idx]; });
  return { data: decimated, indices: indices };
}

// チーム別スタッツのグラフ描画
$(document).on('turbolinks:load', function() {
  initTeamChartTabs();
  initTeamPointHistoryChart();
  initTeamRankHistoryChart();
  initTeamRankDistributionChart();
  initTeamWindRadarChart();
  initTeamVsTeamChart();
  initTeamVsTeamListToggle();
});

var hexToRgba = JanrecoUtils.hexToRgba;
var teamZeroLinePlugin = JanrecoUtils.zeroLinePlugin;
var chartDefaults = require('controllers/chart_defaults');
var externalTooltipHandler = chartDefaults.externalTooltipHandler;
var doughnutTooltipHandler = chartDefaults.doughnutTooltipHandler;

// タブ切替
function initTeamChartTabs() {
  var tabs = document.querySelectorAll('.team-stats-page .stats-chart-tab:not(:disabled)');
  if (!tabs.length) return;

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('active'); });
      document.querySelectorAll('.team-stats-page .stats-chart-panel').forEach(function (p) { p.classList.remove('active'); });
      tab.classList.add('active');
      var target = document.getElementById(tab.getAttribute('data-target'));
      if (target) target.classList.add('active');
    });
  });
}

// チームpt推移チャート
function initTeamPointHistoryChart() {
  var canvas = document.getElementById('team-point-history-chart');
  if (!canvas) return;

  // ロケール依存の文言はdata属性経由でHAMLから受け取る
  var matchIndexFormat = canvas.getAttribute('data-match-index-format') || '{n}対局目';
  var cumulativePtLabel = canvas.getAttribute('data-cumulative-pt-label') || '';

  var points = JSON.parse(canvas.dataset.points || '[]');
  var result = decimateData(points, 500);
  points = result.data;
  var decimateIndices = result.indices;
  var color = canvas.dataset.color || '#2BA680';

  if (window._teamPointChart) {
    window._teamPointChart.destroy();
  }

  var labels = points.map(function(_, i) {
    var origIdx = decimateIndices ? decimateIndices[i] : i;
    return origIdx === 0 ? '' : origIdx;
  });

  window._teamPointChart = new Chart(canvas, {
    type: 'line',
    data: {
      labels: labels,
      datasets: [{
        label: cumulativePtLabel,
        data: points,
        borderColor: color,
        backgroundColor: hexToRgba(color, 0.1),
        pointRadius: 0,
        pointHoverRadius: 3,
        borderWidth: 2,
        fill: true,
        tension: 0.01
      }]
    },
    options: {
      animation: false,
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        tooltip: {
          enabled: false,
          mode: 'index',
          intersect: false,
          external: externalTooltipHandler,
          callbacks: {
            title: function(context) {
              var idx = context[0].dataIndex;
              var origIdx = decimateIndices ? decimateIndices[idx] : idx;
              if (origIdx === 0) return '';
              return matchIndexFormat.replace('{n}', origIdx);
            },
            label: function(context) {
              var value = context.raw;
              return (value >= 0 ? '+' : '') + value.toFixed(1) + 'pt';
            }
          }
        }
      },
      scales: {
        y: {
          suggestedMin: -100,
          suggestedMax: 100,
          ticks: {
            stepSize: 100,
            font: { size: 10 },
            color: '#808083'
          },
          grid: { color: 'rgba(0, 0, 0, 0.06)' }
        },
        x: {
          grid: { display: false },
          ticks: {
            maxRotation: 0,
            minRotation: 0,
            font: { size: 10 },
            color: '#808083'
          }
        }
      }
    },
    plugins: [teamZeroLinePlugin]
  });
}

// チーム順位推移チャート
function initTeamRankHistoryChart() {
  var canvas = document.getElementById('team-rank-history-chart');
  if (!canvas) return;

  var rawData = canvas.getAttribute('data-ranks');
  var teamCount = parseInt(canvas.getAttribute('data-team-count'), 10);
  var color = canvas.dataset.color || '#2BA680';
  if (!rawData) return;

  // ロケール依存の文言はdata属性経由でHAMLから受け取る
  var matchIndexFormat = canvas.getAttribute('data-match-index-format') || '{n}対局目';
  var rankFormat = canvas.getAttribute('data-rank-format') || '{n}位';
  function formatRank(value) { return rankFormat.replace('{n}', value); }

  var ranks = JSON.parse(rawData);
  var originalLength = ranks.length;
  var result = decimateData(ranks, 500);
  ranks = result.data;
  var decimateIndices = result.indices;
  var labels = ranks.map(function (_, i) {
    var origIdx = decimateIndices ? decimateIndices[i] : i;
    return origIdx + 1;
  });

  var stepSize = 1;
  if (teamCount > 20) {
    stepSize = 5;
  } else if (teamCount > 10) {
    stepSize = 2;
  }

  if (window._teamRankChart) {
    window._teamRankChart.destroy();
  }

  window._teamRankChart = new Chart(canvas, {
    type: 'line',
    data: {
      labels: labels,
      datasets: [{
        data: ranks,
        borderColor: color,
        fill: false,
        tension: 0.01,
        pointRadius: originalLength > 50 ? 0 : 2.5,
        pointHoverRadius: 4,
        borderWidth: 2,
        clip: 5
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      animation: false,
      plugins: {
        legend: { display: false },
        tooltip: {
          enabled: false,
          mode: 'index',
          intersect: false,
          external: externalTooltipHandler,
          callbacks: {
            title: function (context) {
              var idx = context[0].dataIndex;
              var origIdx = decimateIndices ? decimateIndices[idx] : idx;
              return matchIndexFormat.replace('{n}', origIdx + 1);
            },
            label: function (context) {
              return formatRank(context.raw);
            }
          }
        }
      },
      scales: {
        x: {
          grid: { display: false },
          ticks: { font: { size: 10 }, color: '#808083', maxRotation: 0 }
        },
        y: {
          reverse: true,
          min: 1,
          max: teamCount,
          ticks: {
            stepSize: stepSize,
            font: { size: 10 },
            color: '#808083',
            callback: function (value) {
              if (Number.isInteger(value)) return formatRank(value);
              return '';
            }
          },
          grid: { color: 'rgba(0, 0, 0, 0.06)' }
        }
      }
    }
  });
}

// 家別レーダーチャート（チームカラー版）
function initTeamWindRadarChart() {
  var canvas = document.getElementById('team-wind-radar-chart');
  if (!canvas) return;

  var rawData = canvas.getAttribute('data-radardata');
  var playType = parseInt(canvas.getAttribute('data-playtype'), 10);
  var color = canvas.dataset.color || '#3FB488';
  if (!rawData) return;

  // ロケール依存の文言はdata属性経由でHAMLから受け取る
  var rankFormat = canvas.getAttribute('data-rank-format') || '{n}位';
  var avgRankLabel = canvas.getAttribute('data-avg-rank-label') || '';
  var noDataLabel = canvas.getAttribute('data-no-data') || '';
  function formatRank(value) { return rankFormat.replace('{n}', value); }

  var radarData = JSON.parse(rawData);

  // 家名はdata属性経由でHAML(t('mahjong_terms.winds.*'))から受け取る（en対応）。
  // data属性欠損時のみ日本語表記へフォールバックする（既存挙動維持）。
  var windNames = { 1: '東', 2: '南', 3: '西', 4: '北' };
  var rawWindNames = canvas.getAttribute('data-wind-names');
  if (rawWindNames) {
    try {
      windNames = JSON.parse(rawWindNames);
    } catch (e) {
      // パース失敗時は上記フォールバックを使用する
    }
  }
  var windLabelColors = { 1: '#D35B4B', 2: '#E8A735', 3: '#4A7FB5', 4: '#8B6BAE' };
  var maxRank = playType;

  var labels = radarData.map(function (d) {
    return windNames[d.ie] || '';
  });

  var roundRect = JanrecoUtils.roundRect;

  // 家ラベルを色付き角丸背景+白文字で描画するプラグイン
  var windLabelPlugin = {
    id: 'teamWindLabel',
    afterDraw: function (chart) {
      var scale = chart.scales.r;
      var ctx = chart.ctx;

      scale.getLabels().forEach(function (label, i) {
        var pos = scale.getPointLabelPosition(i);
        var centerX = (pos.left + pos.right) / 2;
        var centerY = (pos.top + pos.bottom) / 2;
        var ie = radarData[i] ? radarData[i].ie : 0;
        var bgColor = windLabelColors[ie] || '#616168';

        var fontSize = 12;
        var paddingX = 7;
        var paddingY = 3;
        var radius = 3;

        ctx.save();
        ctx.font = 'bold ' + fontSize + 'px -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial';
        var textWidth = ctx.measureText(label).width;
        var boxW = textWidth + paddingX * 2;
        var boxH = fontSize + paddingY * 2;
        var boxX = centerX - boxW / 2;
        var boxY = centerY - boxH / 2;

        roundRect(ctx, boxX, boxY, boxW, boxH, radius);
        ctx.fillStyle = bgColor;
        ctx.fill();

        ctx.fillStyle = '#ffffff';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(label, centerX, centerY);
        ctx.restore();
      });
    }
  };

  var dataValues = radarData.map(function (d) {
    if (d.avg_rank === null || d.match_count === 0) {
      return maxRank;
    }
    return d.avg_rank;
  });

  if (window._teamWindRadarChart) {
    window._teamWindRadarChart.destroy();
  }

  window._teamWindRadarChart = new Chart(canvas, {
    type: 'radar',
    data: {
      labels: labels,
      datasets: [{
        data: dataValues,
        backgroundColor: hexToRgba(color, 0.15),
        borderColor: color,
        borderWidth: 2,
        pointBackgroundColor: '#ffffff',
        pointBorderColor: color,
        pointBorderWidth: 2,
        pointRadius: 3,
        pointHoverRadius: 5
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: true,
      layout: {
        padding: 14
      },
      plugins: {
        legend: { display: false },
        tooltip: {
          enabled: false,
          external: externalTooltipHandler,
          callbacks: {
            title: function (items) {
              var label = items[0].label;
              return Array.isArray(label) ? label[0] : label;
            },
            label: function (context) {
              var d = radarData[context.dataIndex];
              if (d.avg_rank === null || d.match_count === 0) {
                return noDataLabel;
              }
              return avgRankLabel + ': ' + formatRank(d.avg_rank);
            }
          }
        }
      },
      scales: {
        r: {
          reverse: true,
          min: 1.0,
          max: maxRank,
          ticks: {
            stepSize: 1,
            display: true,
            callback: function (value) {
              return formatRank(value);
            },
            font: { size: 10 },
            color: '#808083',
            backdropColor: 'transparent'
          },
          grid: {
            color: 'rgba(0, 0, 0, 0.08)',
            circular: false
          },
          angleLines: {
            color: 'rgba(0, 0, 0, 0.08)'
          },
          pointLabels: {
            font: { size: 14, weight: 'bold' },
            color: 'transparent',
            padding: 12
          }
        }
      }
    },
    plugins: [windLabelPlugin]
  });
}

var getTeamPointHeatmapColor = JanrecoUtils.getPointHeatmapColor;

// チーム別成績横棒グラフ
function initTeamVsTeamChart() {
  var canvas = document.getElementById('team-vs-team-chart');
  if (!canvas) return;

  var rawData = canvas.getAttribute('data-vs-team');
  if (!rawData) return;

  var vsTeamData = JSON.parse(rawData);
  if (vsTeamData.length === 0) return;

  var labels = vsTeamData.map(function (d) { return d.name || ''; });
  var values = vsTeamData.map(function (d) { return d.point; });
  var barColors = values.map(function (v) {
    return getTeamPointHeatmapColor(v);
  });

  var barHeight = 32;
  var chartHeight = Math.max(vsTeamData.length * barHeight + 40, 120);
  canvas.parentElement.style.height = chartHeight + 'px';

  // 0ライン強調プラグイン
  var zeroLinePlugin = {
    id: 'teamVsZeroLine',
    afterDraw: function (chart) {
      var xScale = chart.scales.x;
      var ctx = chart.ctx;
      var x = xScale.getPixelForValue(0);
      if (x >= chart.chartArea.left && x <= chart.chartArea.right) {
        ctx.save();
        ctx.strokeStyle = 'rgba(0, 0, 0, 0.25)';
        ctx.lineWidth = 1;
        ctx.setLineDash([4, 4]);
        ctx.beginPath();
        ctx.moveTo(x, chart.chartArea.top);
        ctx.lineTo(x, chart.chartArea.bottom);
        ctx.stroke();
        ctx.restore();
      }
    }
  };

  // バー内にデータラベル描画するプラグイン
  var barLabelPlugin = {
    id: 'teamVsBarLabel',
    afterDatasetsDraw: function (chart) {
      var ctx = chart.ctx;
      var meta = chart.getDatasetMeta(0);
      var xScale = chart.scales.x;
      var zeroX = xScale.getPixelForValue(0);

      meta.data.forEach(function (bar, index) {
        var value = chart.data.datasets[0].data[index];
        var label = (value > 0 ? '+' : '') + value.toFixed(1);

        ctx.save();
        ctx.font = '10px -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial';
        ctx.fillStyle = '#ffffff';
        ctx.textBaseline = 'middle';

        var barWidth = Math.abs(bar.x - zeroX);
        var textWidth = ctx.measureText(label).width;

        if (barWidth > textWidth + 8) {
          ctx.textAlign = value >= 0 ? 'right' : 'left';
          var x = value >= 0 ? bar.x - 4 : bar.x + 4;
          ctx.fillText(label, x, bar.y);
        } else {
          ctx.fillStyle = '#393944';
          ctx.textAlign = value >= 0 ? 'left' : 'right';
          var x = value >= 0 ? bar.x + 4 : bar.x - 4;
          ctx.fillText(label, x, bar.y);
        }

        ctx.restore();
      });
    }
  };

  if (window._teamVsTeamChart) {
    window._teamVsTeamChart.destroy();
  }

  window._teamVsTeamChart = new Chart(canvas, {
    type: 'bar',
    data: {
      labels: labels,
      datasets: [{
        data: values,
        backgroundColor: barColors,
        borderRadius: 3,
        barThickness: 18
      }]
    },
    options: {
      indexAxis: 'y',
      responsive: true,
      maintainAspectRatio: false,
      animation: false,
      plugins: {
        legend: { display: false },
        tooltip: {
          enabled: false,
          external: externalTooltipHandler,
          callbacks: {
            label: function (context) {
              var value = context.raw;
              return (value >= 0 ? '+' : '') + value.toFixed(1) + 'pt';
            }
          }
        }
      },
      scales: {
        x: {
          grid: { color: 'rgba(0, 0, 0, 0.06)' },
          ticks: {
            font: { size: 10 },
            color: '#808083',
            callback: function (value) {
              return (value > 0 ? '+' : '') + value;
            }
          }
        },
        y: {
          grid: { display: false },
          ticks: {
            font: { size: 12, weight: 'bold' },
            color: '#393944'
          }
        }
      }
    },
    plugins: [zeroLinePlugin, barLabelPlugin]
  });
}

// チーム順位分布ドーナツチャート
function initTeamRankDistributionChart() {
  var canvas = document.getElementById('team-rank-distribution-chart');
  if (!canvas) return;

  var rawData = canvas.getAttribute('data-chartdata');
  var averageRank = canvas.getAttribute('data-averagerank');
  var teamColor = canvas.getAttribute('data-color') || '#2BA680';
  if (!rawData) return;

  // ロケール依存の文言はdata属性経由でHAMLから受け取る
  var rankFormat = canvas.getAttribute('data-rank-format') || '{n}位';
  var avgRankLabel = canvas.getAttribute('data-avg-rank-label') || '';
  var noDataLabel = canvas.getAttribute('data-no-data') || '';
  function formatRank(value) { return rankFormat.replace('{n}', value); }

  var chartData = JSON.parse(rawData);

  var labels = chartData.map(function (d) { return formatRank(d.rank); });
  var data = chartData.map(function (d) { return d.count; });

  // チームカラーの濃淡で各順位の色を生成
  var alphaValues = [1.0, 0.7, 0.45, 0.2];
  var colors = chartData.map(function (d, i) {
    return hexToRgba(teamColor, alphaValues[i] || 0.2);
  });

  // 全データが0件の場合、グレーのプレースホルダーリングを表示
  var totalCount = data.reduce(function (a, b) { return a + b; }, 0);
  var isEmptyData = totalCount === 0;
  var displayData = isEmptyData ? [1] : data;
  var displayColors = isEmptyData ? ['#E0E0E0'] : colors;
  var displayLabels = isEmptyData ? [noDataLabel] : labels;

  // 中央テキスト描画プラグイン
  var centerTextPlugin = {
    id: 'teamRankCenterText',
    afterDraw: function (chart) {
      var ctx = chart.ctx;
      var width = chart.width;
      var height = chart.height;

      ctx.save();
      ctx.font = '12px -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial';
      ctx.fillStyle = '#808083';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(avgRankLabel, width / 2, height / 2 - 10);

      ctx.font = 'bold 18px -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial';
      ctx.fillStyle = '#393944';
      ctx.fillText(averageRank, width / 2, height / 2 + 14);
      ctx.restore();
    }
  };

  if (window._teamRankDistChart) {
    window._teamRankDistChart.destroy();
  }

  window._teamRankDistChart = new Chart(canvas, {
    type: 'doughnut',
    data: {
      labels: displayLabels,
      datasets: [{
        data: displayData,
        backgroundColor: displayColors,
        borderWidth: isEmptyData ? 0 : 2,
        borderColor: '#ffffff',
        hoverBackgroundColor: isEmptyData ? ['#E0E0E0'] : undefined
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: true,
      cutout: '60%',
      animation: false,
      plugins: {
        legend: { display: false },
        tooltip: {
          enabled: false,
          external: isEmptyData ? undefined : doughnutTooltipHandler
        }
      }
    },
    plugins: [centerTextPlugin]
  });
}

// チーム別成績リスト展開/折りたたみトグル
function initTeamVsTeamListToggle() {
  $('.team-vs-team-list-toggle').off('click').on('click', function() {
    $(this).next('.team-vs-team-list').slideToggle(300);
    $(this).find('.fa').toggleClass('fa-chevron-down fa-chevron-up');
    // ロケール依存ラベルはdata属性経由でHAMLから受け取る
    var $toggle = $(this);
    var $text = $toggle.find('.team-vs-team-list-toggle-text');
    var labelShow = $toggle.data('label-show');
    var labelHide = $toggle.data('label-hide');
    if ($text.text() === labelShow) {
      $text.text(labelHide);
    } else {
      $text.text(labelShow);
    }
  });
}
